import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Select} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {installationSelectData, locationsSelectData, showAddRowModal} from "../../redux-store/selectors";
import {
    addDynamicTableRow,
    initializeAddRowModal,
    setShowAddRowModal,
    unmountAddRowModal
} from "../../redux-store/dynamicTable";

const {Option} = Select

function TableConfigAddRow({id}) {

    const show = useSelector(showAddRowModal).find(modal => modal.id === id)?.show || false
    const {selected} = useSelector(installationSelectData)
    const locationSelect = useSelector(locationsSelectData)
    const dispatch = useDispatch()

    const [selectedOption, setSelectedOption] = useState()

    useEffect(() => {
        dispatch(initializeAddRowModal(id))
        return () => {
            dispatch(unmountAddRowModal(id))
        }
    }, [])

    const handleAddRow = async () => {
        dispatch(addDynamicTableRow({selectedOption: selectedOption, tableId: id, installationId: selected.value}))
    }

    return (
        <Modal
            show={show}
            onHide={() => {
                dispatch(setShowAddRowModal({show: false, id}))
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Dodavanje lokacije</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <Select
                        onChange={(e) => {
                            setSelectedOption(e)
                        }}
                        showSearch
                        className={"form-select"}
                        loading={locationSelect.loading}
                        getPopupContainer={node => node.parentNode}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {locationSelect.options.map((option) => {
                            return (
                                <Option key={option.id} value={option.id}>{option.name}</Option>
                            )
                        })}
                    </Select>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={() => {
                        dispatch(setShowAddRowModal({show: false, id}))
                    }}>
                        Zatvori
                    </button>
                    <button className={"btn btn-modal-confirm"} onClick={handleAddRow}>Dodaj</button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default TableConfigAddRow;